import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ConfirmationModal } from '../ConfirmationModal';
import { useOverlayContext } from '../OverlayContext';
export function UnsavedChangesModal(props) {
    const { testId, title = 'Unsaved changes', primaryButtonLabel = 'Discard changes', secondaryButtonLabel = 'Keep editing', primaryButtonTestId, secondaryButtonTestId, content = 'You have unsaved changes that will be lost if you leave this page', dismissModal } = props;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        /* eslint-disable custom/no-hardcoded-bi-name-in-seagull -- UnsavedChangesModal is a fixed-purpose wrapper owning these inherent actions (rule 6a) */ bi: {
            primaryButton: {
                name: 'discard_changes'
            },
            secondaryButton: {
                name: 'keep_editing'
            },
            closeButton: {
                name: 'close'
            }
        },
        /* eslint-enable custom/no-hardcoded-bi-name-in-seagull */ testId: testId,
        skin: "danger",
        title: title,
        content: content,
        primaryButtonLabel: primaryButtonLabel,
        secondaryButtonLabel: secondaryButtonLabel,
        primaryButtonTestId: primaryButtonTestId,
        secondaryButtonTestId: secondaryButtonTestId,
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: ()=>dismissModal(false),
        useStandardTextColors: true
    });
}
export function useOpenUnsavedChangesModal() {
    const globalContext = useOverlayContext();
    return function openUnsavedChangesModal(props) {
        return globalContext.showModal({
            biName: 'unsaved_changes_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(UnsavedChangesModal, _object_spread_props(_object_spread({}, props), {
                    dismissModal: dismissModal
                }));
            }
        });
    };
}
